var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 9.99967H9.99902M13.999 5.33301H1.99902M10.6657 1.33301V3.33301M5.33236 1.33301V3.33301M5.19902 14.6663H10.799C11.9191 14.6663 12.4792 14.6663 12.907 14.4484C13.2833 14.2566 13.5893 13.9506 13.781 13.5743C13.999 13.1465 13.999 12.5864 13.999 11.4663V5.86634C13.999 4.74624 13.999 4.18618 13.781 3.75836C13.5893 3.38204 13.2833 3.07607 12.907 2.88433C12.4792 2.66634 11.9191 2.66634 10.799 2.66634H5.19902C4.07892 2.66634 3.51887 2.66634 3.09104 2.88433C2.71472 3.07607 2.40876 3.38204 2.21701 3.75836C1.99902 4.18618 1.99902 4.74624 1.99902 5.86634V11.4663C1.99902 12.5864 1.99902 13.1465 2.21701 13.5743C2.40876 13.9506 2.71472 14.2566 3.09104 14.4484C3.51887 14.6663 4.07892 14.6663 5.19902 14.6663Z",
    stroke: "#77553D",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.366f9e9bf3e70182b4927dc65a6ed8db.svg";
export { ForwardRef as ReactComponent };